"use client";
import InnerIconButton from "@mui/material/IconButton/IconButton";
import iconButtonClasses from "@mui/material/IconButton/iconButtonClasses";
import { styled } from "@mui/material/styles";
import { button } from "../../styles/utils/button.module";
export const IconButton = styled(InnerIconButton, {
    shouldForwardProp: (prop) => !["color", "variant", "circular"].includes(prop.toString()),
})(({ theme, color, variant, circular }) => {
    const dt = theme.pixel;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (variant === "contained" && button(dt.cta.contained, ["neutral"], dt))), (variant === "outlined" && Object.assign({ borderStyle: "solid", borderWidth: dt.button.shape.border }, button(dt.cta.outlined, ["neutral"], dt)))), (variant === "inline" && {
        padding: 0,
        background: "transparent !important",
        boxShadow: "none !important",
        [`&.${iconButtonClasses.sizeSmall}`]: {
            minWidth: dt.size.medium,
            minHeight: dt.size.medium,
            "&::after": {
                width: dt.button.small,
                height: dt.button.small,
            },
        },
        [`&.${iconButtonClasses.sizeMedium}`]: {
            minWidth: dt.size.large,
            minHeight: dt.size.large,
            "&::after": {
                width: dt.button.medium,
                height: dt.button.medium,
            },
        },
        [`&.${iconButtonClasses.sizeLarge}`]: {
            minWidth: dt.size.xLarge,
            minHeight: dt.size.xLarge,
            "&::after": {
                width: dt.button.large,
                height: dt.button.large,
            },
        },
        "&::after": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: dt.borderRadius.pill,
        },
    })), (circular && {
        borderRadius: dt.borderRadius.pill,
        padding: 0,
    })), (color === "neutralVariant" && Object.assign({}, (variant !== "contained" && {
        ".PixelIcon": {
            backgroundColor: dt.color.onSurface.variant,
        },
    })))), (color === "primary" && Object.assign(Object.assign({}, button(dt.cta.outlined, ["primary"], dt)), (variant === "contained" && button(dt.cta.contained, ["primary"], dt))))), (color === "secondary" && Object.assign(Object.assign({}, button(dt.cta.outlined, ["secondary"], dt)), (variant === "contained" && button(dt.cta.contained, ["secondary"], dt))))), (color === "inverted" && Object.assign(Object.assign({}, button(dt.cta.outlined, ["inverted"], dt)), (variant === "contained" && button(dt.cta.contained, ["inverted"], dt))))), (color === "error" && Object.assign(Object.assign({}, button(dt.cta.outlined, ["signal", "error"], dt)), (variant === "contained" && button(dt.cta.contained, ["signal", "error"], dt))))), (color === "warning" && Object.assign(Object.assign({}, button(dt.cta.outlined, ["signal", "warning"], dt)), (variant === "contained" && button(dt.cta.contained, ["signal", "warning"], dt))))), (color === "success" && Object.assign(Object.assign({}, button(dt.cta.outlined, ["signal", "success"], dt)), (variant === "contained" && button(dt.cta.contained, ["signal", "success"], dt))))), (color === "info" && Object.assign(Object.assign({}, button(dt.cta.outlined, ["signal", "info"], dt)), (variant === "contained" && button(dt.cta.contained, ["signal", "info"], dt)))));
});
